window.$ = window.jQuery = require('jquery');
// window.Popper = require('popper.js');
require('bootstrap');
require('./parts/home.js');
require('./parts/contact-us.js');
